import _ from 'lodash'
import Head from 'next/head'
import { FC } from 'react'

export interface IDynamicMetaProps {
  title?: string
  subtitle?: string | null
  keywords?: string
  ogTitle?: string
  ogSubtitle?: string
  url?: string
  ogImage?: {
    property: string
    content: string | null
  }
  ogImageSecure?: {
    property: string
    content: string | null
  }
}

const DynamicMeta: FC<IDynamicMetaProps> = ({
  title = '멋쟁이사자처럼',
  ogTitle = '멋쟁이사자처럼',
  url,
  ogImage,
  ogImageSecure,
}) => {
  return (
    <Head>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
      />
      <meta property="og:type" content="website" key="ogType" />
      <title>{title}</title>
      <meta property="og:title" content={`${ogTitle}`} key="ogTitle" />
      {url && <meta property="og:url" content={url} key="ogUrl" />}
      {ogImage && ogImage.content !== null && (
        <meta property={ogImage.property} content={ogImage.content} key="ogImage" />
      )}
      {ogImageSecure && ogImageSecure.content !== null && (
        <meta
          property={ogImageSecure.property}
          content={ogImageSecure.content}
          key="ogImageSecure"
        />
      )}
    </Head>
  )
}

export default DynamicMeta
